<style lang="less" scoped>
.tip {
  display: inline-block;
  .ivu-tooltip-rel {
    span {
      cursor: pointer;
      .ivu-icon {
        cursor: pointer;
      }
    }
    .ivu-icon {
      cursor: pointer;
      color: #3e89dd;
    }
  }
}
</style>

<template>
  <div class="tip" v-if="iconShow === true">
    <Tooltip :content="tip" :placement="placement" :transfer="transfer" v-if="iconleft===true">
      <Icon type="md-help-circle"/>
    </Tooltip>
    {{text}}
    <Tooltip :content="tip" :placement="placement" :transfer="transfer" v-if="iconleft!==true">
      <Icon type="md-help-circle"/>
    </Tooltip>
  </div>
  <div class="tip" v-else>
    <Tooltip :content="tip" :placement="placement" :transfer="transfer">
      <Icon type="md-help-circle" v-if="iconleft===true"/>
      {{text}}
      <Icon type="md-help-circle" v-if="iconleft!==true"/>
    </Tooltip>
  </div>
</template>
<script>
export default {
  name: 'cisTip',
  props: ['text', 'tip', 'placement', 'iconleft', 'iconshow'],
  data: function() {
    return {
      iconShow: this.iconshow ? this.iconshow : false,
      transfer: true
    }
  }
}
</script>
